import { render } from "./circle.vue?vue&type=template&id=3f3b49ba"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/circle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f3b49ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f3b49ba', __exports__)) {
    api.reload('3f3b49ba', __exports__)
  }
  
  module.hot.accept("./circle.vue?vue&type=template&id=3f3b49ba", () => {
    api.rerender('3f3b49ba', render)
  })

}


export default __exports__